import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './HorizontalNav.scss';

var HorizontalNav = /*#__PURE__*/function (_Component) {
  _inherits(HorizontalNav, _Component);

  var _super = _createSuper(HorizontalNav);

  function HorizontalNav() {
    _classCallCheck(this, HorizontalNav);

    return _super.apply(this, arguments);
  }

  _createClass(HorizontalNav, [{
    key: "render",
    value: function render() {
      var leftNavClass = this.props.leftNavClass || "".concat(styles.left, " ").concat(styles.button);
      var rightNavClass = this.props.rightNavClass || "".concat(styles.right, " ").concat(styles.button);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.horizontalNav,
        style: this.props.style
      }, this.props.showLeftNav && /*#__PURE__*/React.createElement("div", {
        className: leftNavClass,
        style: {
          left: this.props.left
        },
        onClick: this.props.onLeftNav
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back"
      })), this.props.children, this.props.showRightNav && /*#__PURE__*/React.createElement("div", {
        className: rightNavClass,
        style: {
          right: this.props.right
        },
        onClick: this.props.onRightNav
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward"
      })));
    }
  }]);

  return HorizontalNav;
}(Component);

_defineProperty(HorizontalNav, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  onLeftNav: PropTypes.func.isRequired,
  onRightNav: PropTypes.func.isRequired,
  showLeftNav: PropTypes.bool.isRequired,
  showRightNav: PropTypes.bool.isRequired,
  left: PropTypes.string.isRequired,
  right: PropTypes.string.isRequired,
  leftNavClass: PropTypes.string,
  rightNavClass: PropTypes.string,
  style: PropTypes.object
});

_defineProperty(HorizontalNav, "defaultProps", {
  left: '36px',
  right: '0px',
  onLeftNav: function onLeftNav() {
    return null;
  },
  onRightNav: function onRightNav() {
    return null;
  },
  showLeftNav: true,
  showRightNav: true,
  leftNavClass: null,
  rightNavClass: null,
  style: {}
});

export { HorizontalNav as default };